import { LocalShipping, Newspaper, Checkroom, Badge, Article, Percent, AdfScanner } from '@mui/icons-material';

export interface MenuItem { name: string; icon: React.ElementType; path: string; }

export const menuItems: MenuItem[] = [
    { name: 'Заказы', icon: LocalShipping, path: '/admin/panel' },
    { name: 'Блог', icon: Newspaper, path: '/admin/panel/blog' },
    { name: 'Товары', icon: Checkroom, path: '/admin/panel/products' },
    { name: 'Паспорта', icon: Badge, path: '/admin/panel/passport' },
    { name: 'Документы', icon: Article, path: '/admin/panel/docs' },
    { name: 'Отчёты', icon: AdfScanner, path: '/admin/panel/docs-gen' },
    { name: 'Пользователи и промокоды', icon: Percent, path: '/admin/panel/promo' },
];
